import React from "react";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListSubheader from "@mui/material/ListSubheader";

import DashboardIcon from "@mui/icons-material/Dashboard";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";

import CustomListDropdown from "../../../../helper-components/misc/CustomListDropdown";
import CustomListItem from "../../../../helper-components/misc/CustomListItem";

import { getLanguage } from "../../../../config/language/language";
import * as Constants from "../../../../config/constants/Constants.js";

/**
 * A sidebar for the whole SPA.
 * Includes all accessible pages with links, dropdown lists, and more.
 */
export default function Sidebar(props) {
    const isMobile = props.browser.isMobile;

    const openDrawer = props.sidebar.openAppDrawer;
    const toggleDrawer = props.sidebar.toggleAppDrawer;
    const closeSidebarIfMobile = isMobile ? (openDrawer ? toggleDrawer : undefined) : undefined;

    const isConnected = props.server.isConnectionToServerEstablished;
    const isLoggedIn = props.user.isLoggedIn;

    return (
        <>
            {/* Overview items */}
            <List component="nav" onClick={closeSidebarIfMobile}>
                {isLoggedIn ? (
                    <CustomListItem
                        {...props}
                        name={getLanguage().SIDEBAR_SEARCH}
                        description={getLanguage().SIDEBAR_SEARCH_TOOLTIP}
                        icon={<SearchIcon />}
                        path="/home"
                        enableNavigation
                        enableTooltip
                    />
                ) : (
                    <CustomListItem
                        {...props}
                        name={getLanguage().SIDEBAR_OVERVIEW}
                        description={getLanguage().SIDEBAR_OVERVIEW_TOOLTIP}
                        icon={<DashboardIcon />}
                        path="/home"
                        enableNavigation
                        enableTooltip
                    />
                )}

                {/* {!isLoggedIn && ( */}
                <CustomListItem
                    {...props}
                    name={getLanguage().SIDEBAR_ABOUT}
                    description={getLanguage().SIDEBAR_ABOUT_TOOLTIP}
                    icon={<InfoIcon />}
                    path="/about"
                    enableNavigation
                    enableTooltip
                />
                {/* )} */}
            </List>

            {/* Drop-down lists */}
            {isConnected && isLoggedIn && (
                <List component="nav">
                    <Divider />

                    <ListSubheader component="div" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {getLanguage().SIDEBAR_DATA_CONFIG}
                    </ListSubheader>

                    <CustomListDropdown {...props} categories={[...Constants.DROPDOWN_CATEGORIES]} />
                </List>
            )}

            {/* Admin subcategories */}
            {isConnected && isLoggedIn && (
                <List component="nav">
                    <Divider />

                    <ListSubheader component="div" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {getLanguage().SIDEBAR_ADMINISTRATION}
                    </ListSubheader>

                    <CustomListDropdown {...props} categories={[Constants.ADMINISTRATION]} />
                </List>
            )}

            <br></br>
            <br></br>
        </>
    );
}
